/* a11y audit fix #4: ensure all carousel prev/next arrow buttons expose an aria-label */
(function () {
function labelArrows() {
document.querySelectorAll(".prev-next-button--prev:not([aria-label])").forEach(function (el) {
el.setAttribute("aria-label", "Previous");
});
document.querySelectorAll(".prev-next-button--next:not([aria-label])").forEach(function (el) {
el.setAttribute("aria-label", "Next");
});
}
function init() {
labelArrows();
var mo = new MutationObserver(labelArrows);
mo.observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();